import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { CreditRow } from "./CreditRow";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "./style.css";
import { CreditError } from "../../../general/creditsLayoutTab";
import { foundSameCount, sortByCount } from "../../../../helpers/creditsArray";
import DateTimePicker from "react-datetime-picker";

export interface CreditProps {
  id: string;
  count: number;
  percent: number;
}

interface Props {
  credits: Array<CreditProps>;
  handleChangeCreditsStatus: () => void;
  isActiveCredits: boolean;
  handleSetCredits: (creditsArr: Array<CreditProps>) => void;
  withDateSelection?: boolean;
  handleSaveCredits: () => void;
  startDate?: Date|string;
  endDate?: Date|string;
  handleSetDateValue?: (dateValue: string, dateType: string) => void;
  dateType?: string;
  handleSetDateType?: (e: any) => void;
  withSaveBtn:boolean;
}

export const CreditsPickerComponent = ({
  credits,
  handleChangeCreditsStatus,
  isActiveCredits,
  handleSetCredits,
  withDateSelection,
  handleSaveCredits,
  startDate,
  endDate,
  handleSetDateValue,
  dateType,
  handleSetDateType,
  withSaveBtn
}: Props) => {
  const [errors, setErrors] = useState<Array<CreditError>>([]);
  const [dateErrors, setDateErrors] = useState<{
    startDateError: string;
    endDateError: string;
  }>({
    startDateError: "",
    endDateError: "",
  });

  useEffect(() => {
    const countDuplicates = foundSameCount(credits);

    if (credits) {
    credits.map((i, index) => {
      const errorExistIndex = errors.findIndex(
        (item) => item.creditId === i.id
      );
      if (errorExistIndex !== -1) {
        setErrors([
          ...errors.slice(0, errorExistIndex),
          (errors[errorExistIndex] = {
            ...errors[errorExistIndex],
            count: countDuplicates.find((duplicate) => duplicate === i.count) || i.count<=0
              ? true
              : false,
            percent: i.percent<=0?true:false
          }),
          ...errors.slice(errorExistIndex + 1),
        ]);
      }
      if (errorExistIndex === -1) {
        setErrors([
          ...errors,
          (errors[errors.length] = {
            creditId: i.id,
            count: i.count <= 0 ? true : false,
            percent: i.percent <= 0 ? true : false,
          }),
        ]);
      }
    })
  }
  }, [credits]);

  const handleAddCredit = () => {
    handleSetCredits([
      ...credits,
      {
        count: credits.length ? credits[credits.length - 1].count + 100 : 100,
        percent: 1,
        id: "_" + Math.random().toString(36).substr(2, 9),
      },
    ]);
  };
  const handleDeleteCredit = (id: string) => () => {
    const index = credits.findIndex((i) => i.id === id);
    const indexOfErrorRow = errors.findIndex((i) => i.creditId === id);
    handleSetCredits([...credits.slice(0, index), ...credits.slice(index + 1)]);
    setErrors([
      ...errors.slice(0, indexOfErrorRow),
      ...errors.slice(indexOfErrorRow + 1),
    ]);
  };

  const handleChangeCreditProps = (id: string) => async (e: any) => {
    const index = credits.findIndex((i) => i.id === id);
    handleSetCredits([
      ...credits.slice(0, index),
      { ...credits[index], [e.currentTarget.name]: +e.currentTarget.value },
      ...credits.slice(index + 1),
    ]);
  };

  const sortCreditsArrayOnBlur = () => {
    const creditsCopy = [...credits];
    const sortedCredits = sortByCount(creditsCopy);
    handleSetCredits(sortedCredits);
  };

  const handleSetStartDate = (value: any) => {
    if (value) {
      const endDateTime = new Date(endDate!).getTime();
      const startDateTime = value.getTime();
      if (startDateTime > endDateTime) {
        setDateErrors({
          ...dateErrors,
          endDateError: "",
          startDateError: "Start date cannot be later than finish date",
        });
      } 
      else if(startDateTime === endDateTime){
        setDateErrors({
          ...dateErrors,
          startDateError: "Start date can't be the same as Finish date",
          endDateError: "",
        });
      }else {
        setDateErrors({
          ...dateErrors,
          endDateError: "",
          startDateError: "",
        });
      }
      handleSetDateValue!(value, "startDateValue");
    }
  };

  const handleSetEndDate = (value: any) => {
    if (value) {
      const startDateTime = new Date(startDate!).getTime();
      const endDateTime = value.getTime();
      if (startDateTime > endDateTime) {
        setDateErrors({
          ...dateErrors,
          startDateError: "",
          endDateError: "Finish date cannot be earlier than Start date",
        });
      } else if(startDateTime === endDateTime){
        setDateErrors({
          ...dateErrors,
          startDateError: "",
          endDateError: "Finish date can't be the same as Start date",
        });
      }
      else {
        setDateErrors({
          ...dateErrors,
          endDateError: "",
          startDateError: "",
        });
      }
      handleSetDateValue!(value, "endDateValue");
    }
  };

  return (
    <Box className="creditsPickerWrapper">
      <Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h6">Status</Typography>
          <Box marginLeft={1}>
            <Switch
              checked={isActiveCredits}
              onChange={handleChangeCreditsStatus}
              color="primary"
              name="checkedB"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </Box>
        </Box>

        {isActiveCredits && withDateSelection ? (
          <Box className="radioButtonsGroup">
            <Box className="radioButtonWrapper">
              <FormControlLabel
                name="allDate"
                onChange={handleSetDateType}
                value="allDate"
                checked={dateType === "allDate"}
                control={<Radio color="default" />}
                label="All Date"
              />
            </Box>
            <Box className="radioButtonWrapper">
              <FormControlLabel
                name="date"
                onChange={handleSetDateType}
                value="date"
                checked={dateType === "date"}
                control={<Radio color="default" />}
                label="Date"
              />
            </Box>
          </Box>
        ) : null}

        {isActiveCredits &&dateType === "date" && (
          <Box marginTop="1.3rem" marginBottom="1.3rem" >
            <Box display="flex" alignItems="center" justifyContent="flex-start">
              <Typography gutterBottom className="base-color">
                Start date
              </Typography>
              <Box>
                <DateTimePicker
                  value={startDate}
                  format={"dd-MM-y h:mm:ss a"}
                  name="startDate"
                  onChange={handleSetStartDate}
                  maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                  minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                />
                <Box position="absolute">
                  {dateErrors.startDateError && (
                    <div className="date-error">
                      {dateErrors.startDateError}
                    </div>
                  )}
                </Box>
                {!startDate && <div className="validate-address-error">Required</div>}
              </Box>
            </Box>
            <Box display="flex" alignItems="center" marginTop="1rem" justifyContent="flex-start">
              <Typography gutterBottom className="base-color">
                End date
              </Typography>
              <Box>
                <DateTimePicker
                  value={endDate}
                  format={"dd-MM-y h:mm:ss a"}
                  onChange={handleSetEndDate}
                  maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                  minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                />
                <Box position="absolute">
                  {dateErrors.endDateError && (
                    <div className="date-error">{dateErrors.endDateError}</div>
                  )}
                </Box>
                {!endDate && <div className="validate-address-error">Required</div>}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      {isActiveCredits && (
        <>
          <Box className="creditsWrapper">
            {credits.map((i, index) => {
              const creditAmountPerPound = +(i.percent * 0.01);
              const errorRow = errors.find((item) => item.creditId === i.id);
              return (
                <>
                  <CreditRow
                    handleChangeCreditProps={handleChangeCreditProps(i.id)}
                    key={i.id}
                    poundsAmount={i.count}
                    handleDeleteCredit={handleDeleteCredit(i.id)}
                    percentForAddingCredits={i.percent}
                    amountOfAddedTickets={creditAmountPerPound}
                    countError={errorRow?.count}
                    percentError={errorRow?.percent}
                    sortCreditsArrayOnBlur={sortCreditsArrayOnBlur}
                  />
                  {index === credits.length - 1 || credits.length === 0 ? (
                    <AddCircleIcon
                      onClick={handleAddCredit}
                      className="add-discount"
                    />
                  ) : null}
                </>
              );
            })}
            {credits.length === 0 ? (
              <AddCircleIcon
                onClick={handleAddCredit}
                className="add-discount"
              />
            ) : null}
          </Box>
        </>
      )}
      {withSaveBtn&&
      <Box>
        <Button
          variant="contained"
          color={
            !errors.find((i) => i.count || i.percent)||!isActiveCredits ? "primary" : "default"
          }
          disableElevation
          disabled={!!errors.find((i) => i.count || i.percent)&&isActiveCredits}
          onClick={handleSaveCredits}
        >
          Save
        </Button>
      </Box>}
    </Box>
  );
};
